import Landing from "../../components/Landing/Landing";

export default function LandingPage() {
  return <Landing />;
}
